// removed by extract-text-webpack-plugin
module.exports = {"faq":"styles__faq__M5Zv_","heading":"styles__heading__3lK7T","quality-heading":"styles__quality-heading__1PYtX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StartupFaq/styles.scss
// module id = 414
// module chunks = 0